/**
 * Shared rules for bug-report attachments vs images (ImageGallery, BugReportDialog).
 * `ImageGallery` uses a single file input without `accept` and classifies with these helpers
 * (avoids mixing MIME tokens and extension lists on one input — Windows "Custom Files" issue).
 */

const IMAGE_MIME_PREFIX = 'image/';

/** Explicit non-image attachment extensions (see `isAcceptedAttachment`). */
export const ACCEPTED_ATTACHMENT_EXTENSIONS_STRING =
  '.xlsx,.xls,.csv,.pdf,.json,.txt,.webm,.mp4';

export const ACCEPTED_ATTACHMENT_EXTENSIONS = new Set(
  ACCEPTED_ATTACHMENT_EXTENSIONS_STRING.split(',').map((e) => e.trim().toLowerCase())
);

export const ACCEPTED_IMAGE_EXTENSIONS = new Set([
  '.png',
  '.jpg',
  '.jpeg',
  '.gif',
  '.webp',
  '.heic',
  '.heif',
  '.bmp',
  '.tif',
  '.tiff',
]);

export function getFileExtensionLower(file: File): string {
  const parts = file.name.split('.');
  if (parts.length < 2) return '';
  return `.${parts.pop()!.toLowerCase()}`;
}

/** Image by MIME or by known image extension (handles Windows empty `file.type`). */
export function isAcceptedImage(file: File): boolean {
  if (file.type.startsWith(IMAGE_MIME_PREFIX)) return true;
  const ext = getFileExtensionLower(file);
  return ACCEPTED_IMAGE_EXTENSIONS.has(ext);
}

/** Non-image attachment allowed by extension list (screenshots/videos use image path first). */
export function isAcceptedAttachment(file: File): boolean {
  const ext = getFileExtensionLower(file);
  return ACCEPTED_ATTACHMENT_EXTENSIONS.has(ext);
}
